import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Site from "@/pages/Site";
import Join from "@/pages/Join";
import Apply from "@/pages/Apply";
import ApplicationReceived from "@/pages/ApplicationReceived";
import BrandKit from "@/pages/BrandKit";
import ProductPage from "@/pages/ProductPage";
import ClientExperiences from "@/pages/ClientExperiences";
import LifeInsuranceChandler from "@/pages/LifeInsuranceChandler";
import Schedule from "@/pages/Schedule";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AccountSettings from "@/pages/AccountSettings";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Site />} />
        <Route path="/about" element={<Site />} />
        <Route path="/products" element={<Site />} />
        <Route path="/quote" element={<Site />} />
        <Route path="/contact" element={<Site />} />
        <Route path="/products/:slug" element={<ProductPage />} />
        <Route path="/client-experiences" element={<ClientExperiences />} />
        <Route path="/life-insurance-chandler-az" element={<LifeInsuranceChandler />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/join" element={<Join />} />
        <Route path="/join/apply" element={<Apply />} />
        <Route path="/join/application-received" element={<ApplicationReceived />} />
        <Route path="/brand" element={<BrandKit />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/settings" element={<AccountSettings />} />
      </Routes>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#f4f0ea",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
